import * as React from "react"
import { CartContext } from "components/cart/CartProvider"

function useCart() {
	const cart = React.useContext(CartContext)
	const quantity = cart.reduce((acc, { quantity }) => acc + quantity, 0)
	return { cart, quantity }
}

export default useCart
